import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly, staffOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center py-32"><Loader2 className="animate-spin text-[#e50000]" size={32} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (staffOnly && user.role !== "admin" && user.role !== "moderator") return <Navigate to="/" replace />;
  return children;
}
